import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classnames from "classnames";

// import Datepicker from "../sub_components/Datepicker_.js";
import ReactDatetime from "react-datetime";
// import DateTimePicker from 'react-datetime-picker';

// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardImg,
  FormGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

import MaterialTable from "material-table";
import Grid from "@material-ui/core/Grid";
import Search from '@material-ui/icons/Search'
import Edit from '@material-ui/icons/Edit'
import Delete from '@material-ui/icons/Delete'
import ViewColumn from '@material-ui/icons/ViewColumn'
import SaveAlt from '@material-ui/icons/SaveAlt'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Add from '@material-ui/icons/Add'
import Check from '@material-ui/icons/Check'
import FilterList from '@material-ui/icons/FilterList'
import Remove from '@material-ui/icons/Remove'
import Clear from '@material-ui/icons/Clear'
import ArrowDownward from "@material-ui/icons/ArrowDownward"
import ArrowUpward from "@material-ui/icons/ArrowUpward"

import {
  addRecord,
  updateRecord,
  deleteRecord,
  readAllRecords
} from "../../services_/bookingConfirmRestService";

import Paper from '@material-ui/core/Paper';
import { ViewState } from '@devexpress/dx-react-scheduler';
import {
  Scheduler,
  DayView,
  WeekView,
  MonthView,
  Toolbar,
  Appointments,
  ViewSwitcher,
  TodayButton,
  DateNavigator,
} from '@devexpress/dx-react-scheduler-material-ui';

import axios from 'axios';
import { appointments } from "./appointments";

import { MultiLang, Determinator } from "react-multi-language";
import Navbar from "components_/sub_components/Navbar.js";

import GoogleMapReact from 'google-map-react'
import { Icon } from '@iconify/react'
import locationIcon from '@iconify/icons-mdi/map-marker'
// const AnyReactComponent = ({ text }) => (
//   <div style={{
//     color: 'black',
//     background: 'grey',
//     padding: '15px 10px',
//     display: 'inline-flex',
//     textAlign: 'center',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '100%',
//     transform: 'translate(-50%, -50%)'
//   }}>
//     {text}
//   </div>
// );
const LocationPin = ({ text }) => (
  <div className="pin">
    <Icon icon={locationIcon} className="pin-icon" />
    <p className="pin-text">{text}</p>
  </div>
);

export default function Venue(props) {
  // class VenueBooking extends React.Component {
  // state = {};
  // componentDidMount() {
  //   document.documentElement.scrollTop = 0;
  //   document.scrollingElement.scrollTop = 0;
  //   this.refs.main.scrollTop = 0;
  // }
  const [scheduleState, setScheduleState] = useState({
    data: [],
    currentViewName: 'work-week',
  });
  const [state, setState] = useState({
    columns: [
      {
        title: "ID",
        field: "id",
        editable: "onAdd"
      },
      {
        title: "Start Time",
        field: "startDate",
        type: "datetime"
      },
      {
        title: "End Time",
        field: "endDate",
        type: "datetime"
      },
      {
        title: "Status",
        field: "members"
      },
      {
        title: "Title",
        field: "title"
      },
      {
        title: "User Name",
        field: "userName"
      },
      {
        title: "User Mobile",
        field: "userMobile"
      },
      {
        title: "User Email",
        field: "userEmail"
      },
      {
        title: "User Organization",
        field: "userOrganization"
      },
      {
        title: "User Title",
        field: "userTitle"
      },
    ],
    data: []
  });

  const [bookingDate, setBookingDate] = useState(null);
  const [bookingCheckboxAM, setBookingCheckboxAM] = useState(false);
  const [bookingCheckboxPM, setBookingCheckboxPM] = useState(false);
  const [termsCheckbox, setTermsCheckbox] = useState(false);

  // for email
  const [bookingId, setBookingId] = useState(10);
  const [bookingStartDate1, setBookingStartDate1] = useState(null);
  const [bookingEndDate1, setBookingEndDate1] = useState(null);
  const [bookingStartDate2, setBookingStartDate2] = useState(null);
  const [bookingEndDate2, setBookingEndDate2] = useState(null);
  const [bookingMember, setBookingMember] = useState(1);
  const [bookingTitle, setBookingTitle] = useState(null);
  const [bookingUserName, setBookingUserName] = useState(null);
  const [bookingUserMobile, setBookingUserMobile] = useState(0);
  const [bookingUserEmail, setBookingUserEmail] = useState(null);
  const [bookingUserOrganization, setBookingUserOrganization] = useState(null);
  const [bookingUserTitle, setBookingUserTitle] = useState(null);

  const [bookingIdFocus, setBookingIdFocus] = useState(false);
  // const [bookingStartDateFocus, setBookingStartDateFocus] = useState(false);
  // const [bookingEndDateFocus, setBookingEndDateFocus] = useState(false);
  // const [bookingMemberFocus, setBookingMemberFocus] = useState(false);
  const [bookingTitleFocus, setBookingTitleFocus] = useState(false);
  const [bookingUserNameFocus, setBookingUserNameFocus] = useState(false);
  const [bookingUserMobileFocus, setBookingUserMobileFocus] = useState(false);
  const [bookingUserEmailFocus, setBookingUserEmailFocus] = useState(false);
  const [bookingUserOrganizationFocus, setBookingUserOrganizationFocus] = useState(false);
  const [bookingUserTitleFocus, setBookingUserTitleFocus] = useState(false);

  const handleChange = e => {
    console.log("handleChange.", e.target.name, e.target.value);
    // if (e.target.name === "bookingId") setBookingId(e.target.value);
    // if (e.target.name === "bookingStartDate") setBookingStartDate(e.target.value);
    // if (e.target.name === "bookingEndDate") setBookingEndDate(e.target.value);
    // if (e.target.name === "bookingMember") setBookingMember(e.target.value);
    if (e.target.name === "bookingTitle") setBookingTitle(e.target.value);
    if (e.target.name === "bookingUserName") setBookingUserName(e.target.value);
    if (e.target.name === "bookingUserMobile") setBookingUserMobile(e.target.value);
    if (e.target.name === "bookingUserEmail") setBookingUserEmail(e.target.value);
    if (e.target.name === "bookingUserOrganization") setBookingUserOrganization(e.target.value);
    if (e.target.name === "bookingUserTitle") setBookingUserTitle(e.target.value);
  };

  // const handleChangeDateTime_bookingStart = date => {
  //   setBookingStartDate(date)
  // }
  // const handleChangeDateTime_bookingEnd = date => {
  //   setBookingEndDate(date)
  // }
  const handleChangeDate = date => {
    setBookingDate(date)
  }

  const googleMap = {
    center: {
      lat: 22.404444,
      lng: 114.221743,
    },
    zoom: 16
  };

  useEffect(() => {
    async function fetchData() {
      const records = await readAllRecords();
      console.log("..[log, FacilitiesBookin.jsx]..")
      console.log(records);
      setState({ columns: state.columns, data: records });
    }
    fetchData();
  }, []);

  // setState is an asynchronous function.
  // # define below
  //     - bookingStartDate1, bookingEndDate1
  //     - bookingStartDate2, bookingEndDate2
  //     - bookingId
  useEffect(() => {
    if (bookingDate != null) {

      let bd_date = new Date(bookingDate._d);
      console.log("..[log, bookingDate] ", bd_date);
      let year = bd_date.getFullYear();
      let year_string = year.toString();
      let month = bd_date.getMonth();
      let month_string = month.toString();

      // FIXME!!! getMonth problem --> july -> 6?!!!!
      console.log("..[log, bd_date.getMonth()] ", bd_date.getMonth());
      console.log("..[log, bd_date.getMonth().toString()] ", month);

      let date = bd_date.getDate();
      let date_string = date.toString();
      let appointment_start1 = new Date(year, month, date, 9, 0);
      let appointment_end1 = new Date(year, month, date, 12, 0);
      // console.log(appointment_start1);
      let appointment_start2 = new Date(year, month, date, 14, 0);
      let appointment_end2 = new Date(year, month, date, 17, 0);

      if (bookingCheckboxAM == true) {

        setBookingStartDate1(appointment_start1.toLocaleString());
        setBookingEndDate1(appointment_end1.toLocaleString());

        if (bookingCheckboxPM == true) {

          let bookingId_string = year_string + month_string + date_string + '09' + '17';
          console.log("..[log, VenueBooking.js, bookingId_string] ", bookingId_string);
          let bookingId_int = parseInt(bookingId_string, 10);
          setBookingId(bookingId_int);
          // console.log("..[log, VenueBooking.js, bookingId_int] ", typeof (bookingId_int));
          // console.log("..[log, VenueBooking.js, bookingId_int] ", bookingId_int);
          console.log("..[log, VenueBooking.js, useEffect(), setBookingId()] ", bookingId);

          setBookingStartDate2(appointment_start2.toLocaleString());
          setBookingEndDate2(appointment_end2.toLocaleString());

        } else {

          let bookingId_string = year_string + month_string + date_string + '09' + '12';
          console.log("..[log, VenueBooking.js, bookingId_string] ", bookingId_string);
          let bookingId_int = parseInt(bookingId_string, 10);
          setBookingId(bookingId_int);
          // console.log("..[log, VenueBooking.js, bookingId_int] ", typeof (bookingId_int));
          // console.log("..[log, VenueBooking.js, bookingId_int] ", bookingId_int);
          console.log("..[log, VenueBooking.js, useEffect(), setBookingId()] ", bookingId);

          setBookingStartDate2(null);
          setBookingEndDate2(null);
        }
      } else {

        setBookingStartDate1(null);
        setBookingEndDate1(null);

        if (bookingCheckboxPM == true) {

          let bookingId_string = year_string + month_string + date_string + '14' + '17';
          console.log("..[log, VenueBooking.js, bookingId_string] ", bookingId_string);
          let bookingId_int = parseInt(bookingId_string, 10);
          setBookingId(bookingId_int);
          // console.log("..[log, VenueBooking.js, bookingId_int] ", typeof (bookingId_int));
          // console.log("..[log, VenueBooking.js, bookingId_int] ", bookingId_int);
          console.log("..[log, VenueBooking.js, useEffect(), setBookingId()] ", bookingId);

          setBookingStartDate2(appointment_start2.toLocaleString());
          setBookingEndDate2(appointment_end2.toLocaleString());

        } else {
          setBookingId(0);
          console.log("..[log, VenueBooking.js] bookingCheckboxAM and bookingCheckboxPM are unchecked!");

          setBookingStartDate2(null);
          setBookingEndDate2(null);
          // // due to ASYNC, may have lag
          // console.log(bookingStartDate2);
          // console.log(bookingEndDate2);

        }
      }
    }
  });

  const handleChangeCheckboxAM = e => {
    console.log("..[log, VenueBooking.js, handleChangeCheckboxAM=>] ", e.target.name, e.target.value);
    setBookingCheckboxAM(!bookingCheckboxAM);
    // // seems have lag time to display the real state value
    // console.log("..[log, VenueBooking.js, handleChangeCheckboxAM=>, bookingCheckboxAM] ", bookingCheckboxAM);
    // if (bookingCheckboxAM == true) {
    //   // seems have lag time to display the real state value
    //   console.log("..[log, bookingCheckboxAM]", bookingCheckboxAM);
    // } else {
    //   // seems have lag time to display the real state value
    //   console.log("..[log, bookingCheckboxAM]", bookingCheckboxAM);
    // }
  }

  const handleChangeCheckboxPM = e => {
    console.log("..[log, VenueBooking.js, handleChangeCheckboxPM=>] ", e.target.name, e.target.value);
    setBookingCheckboxPM(!bookingCheckboxPM);
  }

  const handleChangeCheckboxTerms = e => {
    console.log("..[log, Venue.js, handleChangeCheckboxTerms=>] ", e.target.name, e.target.value);
    setTermsCheckbox(!termsCheckbox);
  }

  const [error, setError] = useState(false);

  // const sleep = (milliseconds) => {
  //   return new Promise(resolve => setTimeout(resolve, milliseconds))
  // }

  const handleSubmit = async () => {
    try {
      console.log("handleSubmit called.");

      axios({
        method: "POST",
        // url: "http://localhost:8080/email_send",
        url: "https://aecom-clc.herokuapp.com/email_send",
        data: { bookingId, bookingStartDate1, bookingEndDate1, bookingStartDate2, bookingEndDate2, bookingMember, bookingTitle, bookingUserName, bookingUserMobile, bookingUserEmail, bookingUserOrganization, bookingUserTitle }
      }).then((response) => {
        if (response.data.status === 'success') {
          alert("Meeting Room Reservation Request Sent.");
        } else if (response.data.status === 'fail') {
          alert("Message failed to send.")
        }
      })

    } catch (ex) {
      // FIXME - error handling page
      if (ex.response && ex.response.status === 400) {
        // const errors = { ...this.state.errors };
        // errors.email = ex.response.data;
        // this.setState({ errors });
        setError(true);
        // window.location = "/login";
        console.log("error - ", error);
        // setError(ex.response.data);        
        // alert('Invalid email / password!');
      }
    }
  };

  const currentViewNameChange = (currentViewName) => {
    setScheduleState({ currentViewName });
  };


  return (
    <>
      <Navbar languageState={props.languageState} updateLanguageState={props.updateLanguageState} />
      {console.log("..[log - VenueBooking.js, languageState] : ", props.languageState)}
      {/* <DemoNavbar /> */}
      {/* <main ref="main"> */}
      <div className="position-relative">
        {/* shape Hero */}
        <section className="section section-lg section-shaped pb-250">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-lg-md d-flex">
            <div className="col px-0">
              <Row>
                <Col lg="6">
                  <h1 className="display-3 text-white">
                    <Determinator>
                      {{
                        en: "Venue Booking ",
                        tw: "場地預約",
                        cn: "场地预约",
                      }}
                    </Determinator>
                    {" "}
                    {/* <span>completed with examples</span> */}
                  </h1>
                  <p className="lead text-white">
                    {/* Please stay close to our website’s announcement. */}
                  </p>
                </Col>
              </Row>
            </div>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-white"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </section>
        {/* 1st Hero Variation */}
      </div>

      <section className="section ">
        {/* <Container className="py-md">
              <Row className="justify-content-between align-items-center">
                <br />
                <Col className="mb-5 mb-lg-0" lg="5">
                  <h1 className="font-weight-light">
                    <Determinator>
                      {{
                        en: "Location Plan",
                        tw: "中心位置",
                        cn: "中心位置",
                      }}
                    </Determinator>
                  </h1>
                </Col>
              </Row>
            </Container> */}
        <Container>
          <Row className="row-grid align-items-center">
            <h1 className="display-3">
              <Determinator>
                {{
                  en: "Location",
                  tw: "中心位置",
                  cn: "中心位置",
                }}
              </Determinator>
            </h1>
          </Row>
          <Row className="row-grid align-items-center">
            <Col md="6">
              {/* // Important! Always set the container height explicitly */}
              <div style={{ height: '40vh', width: '100%' }}>
                {/* <GoogleMapReact
                  bootstrapURLKeys={{ key: 'AIzaSyDoz0l9f90XQJIh_-mTKhQJqpox2gAcUik' }}
                  defaultCenter={googleMap.center}
                  defaultZoom={googleMap.zoom}
                >
                  <LocationPin
                    lat={22.404444}
                    lng={114.221743}
                    text="CLC "
                  />
                </GoogleMapReact> */}
                <a href="https://www.google.com.hk/maps/place/%E6%90%AC%E9%81%B7%E6%B2%99%E7%94%B0%E6%B1%A1%E6%B0%B4%E8%99%95%E7%90%86%E5%8E%B0%E5%BE%80%E5%B2%A9%E6%B4%9E+%E2%80%93+%E7%A4%BE%E5%8D%80%E8%81%AF%E7%B5%A1%E4%B8%AD%E5%BF%83/@22.4043969,114.2195514,17z/data=!3m1!4b1!4m12!1m6!3m5!1s0x34040722b2af912f:0xd2fb4efc991818db!2z5pCs6YG35rKZ55Sw5rGh5rC06JmV55CG5Y6w5b6A5bKp5rSeIOKAkyDnpL7ljYDoga_ntaHkuK3lv4M!8m2!3d22.404392!4d114.2217454!3m4!1s0x34040722b2af912f:0xd2fb4efc991818db!8m2!3d22.404392!4d114.2217454">
                  <CardImg
                    alt="..."
                    src={require("assets_/img_/venue/clc_location.png")}
                    top
                  />
                </a>
              </div>
            </Col>

            {/* <Col md="6">
              <Card className="bg-default shadow border-0">
                <CardImg
                  alt="..."
                  src={require("assets_/img_/activities/i360_202004_steel_bridge_view1_4096.jpg")}
                  top
                />
              </Card>
            </Col> */}
            <Col md="6">
              <br />
              <div className="pl-md-5">
                {/* <div className="icon icon-lg icon-shape icon-shape-warning shadow rounded-circle mb-5">
                      <i className="ni ni-settings" />
                    </div> */}

                <p className="lead">
                  <Determinator>
                    {{
                      en: "Address: Mui Tsz Lam Road, Ma On Shan",
                      tw: "地點：馬鞍山梅子林路",
                      cn: "地点：马鞍山梅子林路",
                    }}
                  </Determinator>
                </p>
                <p className="lead">
                  <Determinator>
                    {{
                      en: "Telephone: (852) 5220 0180",
                      tw: "電話：(852) 5220 0180",
                      cn: "电话：(852) 5220 0180",
                    }}
                  </Determinator>
                </p>
                <p className="lead">
                  <Determinator>
                    {{
                      en: "Fax: (852) 3914 5888",
                      tw: "傳真：(852) 3914 5888",
                      cn: "传真：(852) 3914 5888",
                    }}
                  </Determinator>
                </p>
                <p className="lead">
                  <Determinator>
                    {{
                      en: "E-mail: pr@stc-aecom.com",
                      tw: "電郵：pr@stc-aecom.com",
                      cn: "电邮：pr@stc-aecom.com",
                    }}
                  </Determinator>
                </p>
                <p className="lead">
                  <Determinator>
                    {{
                      en: "Office Hour :",
                      tw: "辦公時間 ：",
                      cn: "办公时间 ：",
                    }}
                  </Determinator>   
                  <br/>             
                  <Determinator>
                    {{
                      en: "\xa0 \xa0 (Mon to Fri) 09:00 - 12:00 & 13:00 - 1800",
                      tw: "\xa0 \xa0 （週一至週五） 09:00 - 12:00 & 13:00 - 1800",
                      cn: "\xa0 \xa0 （周一至周五） 09:00 - 12:00 & 13:00 - 1800",
                    }}
                  </Determinator>
                  <br/>
                  <Determinator>
                    {{
                      en: "\xa0 \xa0 (Sat) 09:00 - 13:00",
                      tw: "\xa0 \xa0 （週六） 09:00 - 13:00",
                      cn: "\xa0 \xa0 （周六） 09:00 - 13:00",
                    }}
                  </Determinator>
                </p>
                {/* <p>
                      The kit comes with three pre-built pages to help you get
                      started faster. You can change the text and images and
                      you're good to go.
                    </p> */}
                {/* <a
                      className="font-weight-bold text-warning mt-5"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      More meaningful works are coming soon.
                    </a> */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section className="section section-lg pt-lg-0 mt--200"> */}
      <section className="section  bg-secondary">
        <Container>
          <Row className="row-grid align-items-center">
            <Col md="12">
              <h3>
                <Determinator>
                  {{
                    en: "Online booking system",
                    tw: "場地預約系统",
                    cn: "场地预约系统",
                  }}
                </Determinator>
              </h3>
              <br />
              <br />
              <br />
              <br />
            </Col>
          </Row>
          <Paper>
            
            {/* <Scheduler
              data={state.data}
              height={600}
            >
              <ViewState
                // defaultCurrentDate="2020-06-28"
                currentViewName={"work-week"}
                onCurrentViewNameChange={currentViewNameChange}
              />
              <WeekView
                name="work-week"
                displayName="Work Week"
                cellDuration={60}
                excludedDays={[0, 7]}
                startDayHour={8}
                endDayHour={18}
              />
              <Toolbar />
              <TodayButton />
              <Appointments />
              <DateNavigator />
            </Scheduler> */}

            <a href="#" >
              <CardImg
                alt="..."
                src={require("assets_/img_/venue/clc_booking_calendar_covid19.png")}
                top
              />
            </a>

          </Paper>
        </Container>
      </section>


      {/* <section className="section section-lg bg-gradient-default">
        <Container className="pt-lg pb-300">
        </Container>
        <div className="separator separator-bottom separator-skew zindex-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon
              className="fill-white"
              points="2560 0 2560 100 0 100"
            />
          </svg>
        </div>
      </section> */}

      {/* email */}
      {/* <section className="section section-lg pt-lg-0 section-contact-us "> */}
      
      <section className="section ">
        <Container>
          
          <a href="#" >
              <CardImg
                alt="..."
                src={require("assets_/img_/venue/clc_booking_form_covid19.png")}
                top
              />
            </a>
          
          {/* <Row className="justify-content-center">
            <Col lg="8">
              <Card className="bg-gradient-secondary shadow">
                <CardBody className="p-lg-5">
                  <h4 className="mb-1">
                    <Determinator>
                      {{
                        en: "Venue Reservation Request Form",
                        tw: "場地預約申請表",
                        cn: "场地预约申请表",
                      }}
                    </Determinator>
                  </h4>

                  <FormGroup
                    className={classnames("mt-5")}
                  >
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <ReactDatetime
                        name="bookingDate"
                        value={bookingDate}
                        onChange={handleChangeDate}
                        inputProps={{
                          placeholder: "Booking Date / 預定日期"
                        }}
                        timeFormat={false}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <div>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        &nbsp;
                      </div>
                      <div className="custom-control custom-checkbox mb-3">
                        <input
                          className="custom-control-input"
                          // defaultChecked
                          name="bookingStartDateAM"
                          id="customCheck1"
                          type="checkbox"
                          onChange={handleChangeCheckboxAM}
                        />
                        <label className="custom-control-label" htmlFor="customCheck1">
                          <span>AM ( 09:00 - 12:00 ) </span>
                        </label>
                      </div>
                      <div>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        &nbsp;
                      </div>
                      <div className="custom-control custom-checkbox mb-3">
                        <input
                          className="custom-control-input"
                          name="bookingStartDatePM"
                          id="customCheck2"
                          type="checkbox"
                          onChange={handleChangeCheckboxPM}
                        />
                        <label className="custom-control-label" htmlFor="customCheck2">
                          <span>PM ( 14:00 - 17:00 )</span>
                        </label>
                      </div>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingTitle"
                        placeholder="Purpose / 用途"
                        type="text"
                        onFocus={e => setBookingTitleFocus(true)}
                        onBlur={e => setBookingTitleFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingUserName"
                        placeholder="User Name / 登記者姓名"
                        type="text"
                        onFocus={e => setBookingUserNameFocus(true)}
                        onBlur={e => setBookingUserNameFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingUserMobile"
                        placeholder="User Mobile / 登記者電話"
                        type="text"
                        onFocus={e => setBookingUserMobileFocus(true)}
                        onBlur={e => setBookingUserMobileFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingUserEmail"
                        placeholder="User Email / 登記者電郵"
                        type="text"
                        onFocus={e => setBookingUserEmailFocus(true)}
                        onBlur={e => setBookingUserEmailFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingUserOrganization"
                        placeholder="User Organization / 登記者公司"
                        type="text"
                        onFocus={e => setBookingUserOrganizationFocus(true)}
                        onBlur={e => setBookingUserOrganizationFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <InputGroup >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="bookingUserTitle"
                        placeholder="User Title / 登記者公司職位"
                        type="text"
                        onFocus={e => setBookingUserTitleFocus(true)}
                        onBlur={e => setBookingUserTitleFocus(false)}
                        onChange={handleChange}
                      />
                    </InputGroup>
                  </FormGroup>

                  <FormGroup>
                    <div className="custom-control custom-checkbox mb-3">
                      <input
                        className="custom-control-input"
                        name="termsCheckbox"
                        type="checkbox"
                        id="termsCheckbox"
                        // checked={termsCheckbox}
                        onChange={handleChangeCheckboxTerms}
                      />
                      <label className="custom-control-label" htmlFor="termsCheckbox">
                        <Determinator>
                          {{
                            en: "I agree to the Terms & Conditions of Venue Booking",
                            tw: "本人同意預約場地條件與細則",
                            cn: "本人同意预约场地条件与细则",
                          }}
                        </Determinator>                        
                      </label>
                    </div>
                  </FormGroup>


                  <div>
                    <Button
                      block
                      className="btn-round"
                      color="default"
                      size="lg"
                      type="button"
                      onClick={handleSubmit}
                      disabled={!termsCheckbox}
                    >
                      Send Message
                        </Button>
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row> */}
        </Container>
      </section>

      <section className="section bg-secondary text-align-justify">
        <Container>
          <Row className="row-grid align-items-center">
            <Col md="12">
              <h3>
                <Determinator>
                  {{
                    en: "Terms & Conditions of Venue Booking ",
                    tw: "預約場地條件與細則",
                    cn: "预约场地条件与细则",
                  }}
                </Determinator>
              </h3>
              <br />
              <div className="pl-md-5">

                <h4 className="lead mt-4">
                  <Determinator>
                    {{
                      en: "Inclement Weather Arrangement",
                      tw: "惡劣天氣時中心開放安排",
                      cn: "恶劣天气时中心开放安排",
                    }}
                  </Determinator>
                </h4>
                <p className="lead mt-4">
                  <Determinator>
                    {{
                      en: "Tropical Cyclone Warning Signal No.8 or above: The centre will be closed. It will remain closed if the signal is lowered less than 3 hours before the usual closing time.",
                      tw: "8號或以上颱風警告：中心將會關閉，倘若8號或以上颱風警告除下時距離中心關閉時間不足三小時，當日將不會開放。",
                      cn: "8号或以上台风警告：中心将会关闭，倘若8号或以上台风警告除下时距离中心关闭时间不足三小时，当日将不会开放。",
                    }}
                  </Determinator>
                </p>
                <p className="lead mt-4">
                  <Determinator>
                    {{
                      en: "Black Rainstorm Warning: If the warning is issued while the centre is in service, the usual opening hours will remain unchanged. If the warning is issued before opening hours, the centre will be resumed within 2 hours after cancellation of the warning. It will remain closed if the warning is cancelled less than 3 hours before the usual closing time.",
                      tw: "黑色暴雨警告：若中心已經開放，中心將維持開放。若黑色暴雨警告在中心開放前經已生效，中心將不會開放，並於黑色暴雨警告除下兩小時內重新開放；倘若除下時距離中心關閉時間不足三小時，當日將不會開放。",
                      cn: "黑色暴雨警告：若中心已经开放，中心将维持开放。若黑色暴雨警告在中心开放前经已生效，中心将不会开放，并于黑色暴雨警告除下两小时内重新开放；倘若除下时距离中心关闭时间不足三小时，当日将不会开放。",
                    }}
                  </Determinator>
                </p>
                <br />
                <h4 className="lead mt-4">
                  <Determinator>
                    {{
                      en: "Notice to Visitors",
                      tw: "參觀者注意事項",
                      cn: "参观者注意事项",
                    }}
                  </Determinator>
                </h4>
                <ol>
                  <li>
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "Please refrain from activities which may affect the operation of the centre. Activities which may affect other visitors in the venue, including but not limited to using a camera with tripod, or video camera, require prior approval from management. If in doubt, please seek advice from staff first.",
                          tw: "請勿進行任何可能影響中心運作的活動。所有可能影響參觀者的活動(如攝錄、使用配備三腳架的相機及其他)，必須預先獲中心職員批准。如有疑問，請先向職員查詢。",
                          cn: "请勿进行任何可能影响中心运作的活动。所有可能影响参观者的活动(如摄录、使用配备三脚架的相机及其他)，必须预先获中心职员批准。如有疑问，请先向职员查询",
                        }}
                      </Determinator>
                    </p>
                  </li>
                  <li>
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "For your personal safety and for the benefit of all visitors, please follow the advice below:",
                          tw: "為閣下安全及參觀者利益起見，請遵從下列建議：",
                          cn: "为阁下安全及参观者利益起见，请遵从下列建议：",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "- Do not shake or damage the exhibits.",
                          tw: "-	切勿搖動或破壞展品；",
                          cn: "-	切勿摇动或破坏展品；",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "- Use the interactive exhibits with care.",
                          tw: "-	小心使用互動學習資訊設施；",
                          cn: "- 小心使用互动学习资讯设施；",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "- Do not push or strike the glass panels.",
                          tw: "-	切勿推撞或碰擊玻璃；",
                          cn: "- 切勿推撞或碰击玻璃；",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "- Do not run, eat or drink inside the venue.",
                          tw: "-	切勿於中心內奔跑或飲食；",
                          cn: "- 切勿于中心内奔跑或饮食；",
                        }}
                      </Determinator>
                      <br />
                      <Determinator>
                        {{
                          en: "- Do not bring dogs to the centre (except guide dogs)  ",
                          tw: "-	切勿攜帶狗隻進入(導盲犬除外)。",
                          cn: "- 切勿携带狗只进入(导盲犬除外)。",
                        }}
                      </Determinator>
                    </p>
                  </li>
                  <li>
                    <p className="lead">
                      <Determinator>
                        {{
                          en: "Follow the advice of the management staff when required; your cooperation and help are essential.",
                          tw: "請聽從現場工作人員指示，你的合作至為重要。",
                          cn: "请听从现场工作人员指示，你的合作至为重要。",
                        }}
                      </Determinator>
                    </p>
                  </li>
                </ol>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <MultiLang lang={props.languageState.lang} />
    </>
  );

}
